import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * El rotulo que encabeza un bloque: «HABLAR CON», «CONVERSACIONES», «ENTRADA».
 * No es un titulo de seccion -eso es `text-lg`-, es la etiqueta en versales que
 * dice de que va lo que viene debajo.
 *
 * Existe porque no existia. Medido el 2026-09-12: **65 usos en 21 ficheros,
 * escritos de 27 formas distintas** -text-[10px], text-[11px] y text-xs;
 * tracking-wide, wider y widest; font-normal, medium, semibold y bold-. Nadie
 * lo hizo mal: no habia donde elegirlo, asi que cada pantalla lo volvio a
 * escribir a ojo.
 *
 * El margen NO va aqui. La separacion con lo que viene debajo es ritmo de la
 * vista -mb-1.5, mb-2, mb-3 segun lo que sea-, no una propiedad del rotulo.
 */
export function RotuloDeSeccion({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      className={cn(
        'text-xs font-medium uppercase tracking-wide text-muted-foreground',
        className,
      )}
      {...props}
    />
  )
}
